import React from "react";

const Modification = () => {
  return (
    <div className="flex flex-col items-start sm:px-16 p-6">
      <h1 className="text-[1.9rem] font-bold tracking-wide ">
        F.
        <span className="text-[#01A7D1] ">
          {" "}
          MODIFICATIONS TO OR TERMINATION OF PLATFORM
        </span>
      </h1>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          1. Modification or Cessation of Platform
        </h1>
        Yostel reserves the right at any time and from time to time to modify or
        discontinue, temporarily or permanently, the Platform (or any part
        thereof) with or without notice and in its sole discretion. You agree
        that Yostel shall not be liable to you or to any third party for any
        modification, suspension or discontinuance of Yostel services.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          2. Termination by Yostel
        </h1>
        You hereby acknowledge and agree that Yostel, in its sole and absolute
        discretion, has the right (but not the obligation) to delete, terminate,
        or deactivate your Account, block your email or IP address, cancel the
        Platform or otherwise terminate your access to or participation in the
        use of the Platform (or any part thereof), or remove and discard any
        Submitted Content on the Platform ("Termination of Service"),
        immediately and without notice, for any reason, including without
        limitation, Account inactivity or if Yostel believes or has reason to
        believe that you have violated any provision of the Terms of Use.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          3. Termination by You
        </h1>
        Since your usage of the Platform is linked to the duration of your stay
        with Yostel, your usage of the Platform shall be terminated when your
        stay with Yostel is terminated and/or expires.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        <h1 className="text-[1.5rem] font-bold tracking-wide pb-3">
          4. Effect of Termination
        </h1>
        Upon termination of your Account, your right to participate in the
        Platform shall automatically be terminated. In the event of Termination
        of Service, your Account will be disabled and you may not be granted
        access to your Account or any files or other data contained in your
        Account. Notwithstanding the foregoing, residual data may remain in the
        Yostel Platform. Unless Yostel has previously cancelled or terminated
        your use of the Platform (in which case subsequent notice by Yostel
        shall not be required), if you provided a valid email address during
        registration, Yostel will notify you via email of any such termination
        or cancellation, which shall be effective immediately upon Yostel 's
        delivery of such notice.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        Upon Termination of Service, the following shall occur: all licenses
        granted to you hereunder will immediately terminate; and you shall
        promptly destroy all copies of Yostel Data (as defined below), Marks (as
        defined below) and other content in your possession or control. You
        further acknowledge and agree that Yostel shall not be liable to you or
        any third party for any termination of your access to the Platform. Upon
        Termination of Service, Yostel retains the right to use any data
        collected from your use of the Platform for internal analysis and
        archival purposes, and all related licenses you have granted Yostel
        hereunder shall remain in effect for the foregoing purpose. In no event
        is Yostel obligated to return any Submitted Content to you. Sections
        which are designed / required to survive termination, shall survive
        expiration or termination of the Platform or your Account.
      </p>
      <p className="text-md  text-[#444444] tracking-wide pt-3">
        You agree to indemnify and hold Yostel, and its officers, managers,
        members, affiliates, successor, assigns, directors, agents, suppliers,
        and employees harmless from any claim or demand, including reasonable
        attorneys' fees and court costs, made by any third party due to or
        arising out of the Termination of Service.
      </p>
    </div>
  );
};

export default Modification;
